export class HttpUserService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async authorize() {
    const res = await fetch(`${this.baseUrl}/api/v1/users/authorize`, {
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    const user = await res.json();

    return user;
  }

  async login(email, password) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    const user = await res.json();

    return user;
  }

  async logout() {
    return fetch(`${this.baseUrl}/api/v1/users/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  }

  async search(filters) {
    const queryParams = new URLSearchParams();

    if (filters.name) {
      queryParams.append('name', filters.name);
    }

    if (filters.role) {
      queryParams.append('role', filters.role);
    }

    const res = await fetch(`${this.baseUrl}/api/v1/users?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async invite(email) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/invite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async create(user) {
    const res = await fetch(`${this.baseUrl}/api/v1/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(user),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async update(id, user) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(user),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async changeEmail(id, email) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}/email`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async changeRole(id, role) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}/role`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ role }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async changePassword(id, password) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}/password`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ password }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async changeMedias(id, medias) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}/medias`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ medias }),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }


  async updateProfile(id, profile) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}/profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(profile),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async delete(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/users/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }
}
